import { render } from "./FormFills.vue?vue&type=template&id=7c8711df"
import script from "./FormFills.vue?vue&type=script&lang=js"
export * from "./FormFills.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/atiehtejarat-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__